import { JSON_SCHEMAS } from "@components/utils/constants";
import JsonLdSchema from "@libs/schema/JsonLdSchema";
interface ISchema {
  schema: string;
}
const FAQSchema = (props: ISchema): JSX.Element => {
  if (!props.schema) {
    return <></>;
  }

  return (
    <>
      <JsonLdSchema
        data={{ breadcrumbObjects: undefined, schema: props.schema }}
        type={JSON_SCHEMAS.FAQ}
      />
    </>
  );
};

export default FAQSchema;
